const DAY_MS = 24 * 60 * 60 * 1000;

interface TimestampLike {
  toDate?: () => Date;
  seconds?: number;
  nanoseconds?: number;
}

export interface PremiumBonusLike {
  source?: string;
  active?: boolean;
  expiresAt?: unknown;
}

export interface PremiumRemainingInfo {
  daysRemaining: number;
  expiresAt: Date;
  label: string;
  shortLabel: string;
}

function toDate(value: unknown): Date | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date : null;
  }

  if (typeof value !== 'object') {
    return null;
  }

  const timestamp = value as TimestampLike;
  if (typeof timestamp.toDate === 'function') {
    const date = timestamp.toDate();
    return Number.isFinite(date.getTime()) ? date : null;
  }

  if (typeof timestamp.seconds === 'number') {
    const date = new Date(timestamp.seconds * 1000);
    return Number.isFinite(date.getTime()) ? date : null;
  }

  return null;
}

function formatDaysRemaining(daysRemaining: number): string {
  return `${daysRemaining} gün kaldı`;
}

export function resolvePremiumBonusRemainingInfo(
  premiumBonus: PremiumBonusLike | undefined,
  now: Date = new Date()
): PremiumRemainingInfo | null {
  if (
    !premiumBonus?.active ||
    premiumBonus.source !== 'credit_purchase_bonus'
  ) {
    return null;
  }

  const expiresAt = toDate(premiumBonus.expiresAt);
  if (!expiresAt) {
    return null;
  }

  const remainingMs = expiresAt.getTime() - now.getTime();
  if (remainingMs <= 0) {
    return null;
  }

  const daysRemaining = Math.max(1, Math.ceil(remainingMs / DAY_MS));
  const label = formatDaysRemaining(daysRemaining);

  return {
    daysRemaining,
    expiresAt,
    label,
    shortLabel: label,
  };
}
